"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styles_1 = require("@material-ui/core/styles");
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@material-ui/core");
var PreviewStore = __importStar(require("../../../app/store/PreviewStore"));
var components_1 = require("../../../youwell-common/components");
var urls_1 = __importDefault(require("../../../app/urls"));
var taskContentUtils_1 = require("../../../common/taskContentUtils");
var responseUtils_1 = require("../../../youwell-common/responseUtils");
var store_1 = require("../../../app/store");
var useStyles = (0, styles_1.makeStyles)(function () { return (0, core_1.createStyles)({
    root: {
        // Flex-display with wrap needed for card-layout on page
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        '@media print': {
            display: 'block',
        },
    },
}); });
var OutsideTaskContent = function (_a) {
    var _b;
    var forwardedRef = _a.forwardedRef, task = _a.task;
    var classes = useStyles();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var allTaskResponses = (0, store_1.useYouwellSelector)(function (state) { return state.previewStore.responses; });
    var allTasksDetails = (0, store_1.useYouwellSelector)(function (state) { return state.previewStore.details; });
    // hack because task.patientProgramElementId is "undefined".. but this works.. Should maybe make more robust?
    var responsesForCurrentTask = (_b = allTaskResponses === null || allTaskResponses === void 0 ? void 0 : allTaskResponses[undefined]) === null || _b === void 0 ? void 0 : _b[task.id];
    var updateResponse = function (responses) {
        var responseData = {
            taskId: task.id,
            taskVersion: task.version,
            responses: responses,
        };
        dispatch(PreviewStore.actionCreators.updateResponse(responseData));
    };
    var saveChanges = function (callback) {
        if (callback) {
            callback();
        }
    };
    var getLinkUrl = function (link) {
        var _a = (0, taskContentUtils_1.parseInternalLink)(link), taskOrModuleId = _a.taskOrModuleId, hash = _a.hash;
        return "".concat(urls_1.default.preview.home, "/").concat(taskOrModuleId).concat(hash);
    };
    var getProgramItem = function (id) { return (allTasksDetails && id ? allTasksDetails[id] : null); };
    return (React.createElement(components_1.TaskContent, { ref: forwardedRef, className: (0, classnames_1.default)(classes.root), LinkElementProps: {
            getLinkUrl: getLinkUrl,
            autoplayVideos: true, // clientConfig.appSetup.features.autoplayVideos,
        }, task: task, taskResponses: responsesForCurrentTask, getProgramItem: getProgramItem, getSpecificTaskResponses: (0, responseUtils_1.getSpecificTaskResponses)(allTaskResponses, responsesForCurrentTask), onResponse: updateResponse, onSaveChanges: saveChanges }));
};
OutsideTaskContent.propTypes = {
    forwardedRef: prop_types_1.default.object,
    task: prop_types_1.default.object.isRequired,
};
OutsideTaskContent.defaultProps = {
    forwardedRef: null,
};
var WithRef = React.forwardRef(function (props, ref) { return React.createElement(OutsideTaskContent, __assign({}, props, { forwardedRef: ref })); });
exports.default = WithRef;
